var map = {
	"./1-1.svg": "3683",
	"./1-2.svg": "ff55",
	"./1-3.svg": "477f",
	"./1-4.svg": "301e",
	"./1-5.svg": "c83d",
	"./2-1.svg": "af5f",
	"./2-2.svg": "f93f",
	"./2-3.svg": "c5bf2",
	"./2-4.svg": "7791",
	"./2-5.svg": "97e6",
	"./3-1.svg": "0e9c",
	"./3-2.svg": "714d",
	"./3-3.svg": "ec20",
	"./3-4.svg": "57a8",
	"./3-5.svg": "ba0c",
	"./4-1.svg": "ecfe",
	"./4-2.svg": "7e99",
	"./4-3.svg": "85fc",
	"./4-4.svg": "a809",
	"./4-5.svg": "ff83",
	"./5-1.svg": "d56f",
	"./5-2.svg": "95cb",
	"./5-3.svg": "a36d",
	"./5-4.svg": "03cb",
	"./5-5.svg": "61dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "14e0";